module.exports = __webpack_public_path__ + "img/usuario.616fcc9d.png";